<template>
    <div class="choose-dialog">
        <transition name="slide">
            <div class="choose-main" v-if="isShow">
                <div class="title">
                    <div style="margin-left:40px;">選擇綁定項目</div>
                    <div class="close" @click="closeDialog"></div>
                </div>
                <div class="text-gray2" style="padding: 20px 0 5px 20px;">
                    綁定項目
                </div>
                <div class="list">
                    <div class="item" @click="$router.push('/payment-add-item')">
                        <img src="@/assets/images/bookFee@3x.png">
                        <span class="text-gray1">學雜費</span>
                    </div>
                    <!--<div class="item">
                        <img src="@/assets/images/iconEsayWallet@3x.png">
                        <span class="text-gray1">其他擴充項目</span>
                    </div>-->
                </div>
            </div>
        </transition>
        <div class="choose-mask" v-if="isShow"></div>
    </div>
</template>

<script>
    export default {
        name: "payment-list-select-dialog",
        props: {
            isShow: {
                type: Boolean,
            }
        },
        methods:{
            closeDialog() {
                //this.is_show = false;
                this.$emit('closeListDialog');
            }
        }
    }
</script>

<style scoped>
    .choose-dialog .choose-main {
        background: #f9f9f9;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
        top: 20%;
        border-top-right-radius: 24pt;
        border-top-left-radius: 24pt;
    }

    .choose-main .title {
        padding: 10px;
        text-align: center;
        background: #FFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top-right-radius: 24pt;
        border-top-left-radius: 24pt;
        font-size: 16px;
    }

    .choose-main .close {
        float: right;
        background: url("../assets/images/deleteNormal@3x.png") no-repeat right;
        background-size: 44px;
        width: 44px;
        height: 44px;
    }

    .choose-main .list {
        background: #FFF;
    }

    .choose-main .list .item {
        padding: 12px 0;
        margin: 0 20px;
        align-items: center;
    }

    .choose-main .list .item:not(:last-child) {
        border-bottom: 1px solid rgba(64, 64, 64, 0.1);
    }

    .choose-main .list .item img {
        width: 32px;
        height: 32px;
        vertical-align: middle;
        margin-right: 8px;
    }

    .choose-mask {
        z-index: 10;
        position: absolute;
        box-sizing: border-box;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        filter: brightness(0.5);
    }

    .slide-enter-active {
        animation-name: slideInUp;
        animation-duration: 0.3s;
        animation-fill-mode: both;
    }

    .slide-leave-active {
        animation-name: slideOutDown;
        animation-duration: 0.3s;
        animation-fill-mode: both;
    }

    @keyframes slideInUp {
        0% {
            transform: translate3d(0, 100%, 0);
            visibility: visible;
        }

        to {
            transform: translateZ(0);
        }
    }

    @keyframes slideOutDown {
        0% {
            transform: translateZ(0);
        }

        to {
            visibility: hidden;
            transform: translate3d(0, 100%, 0);
        }
    }

</style>
